import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import SchemeOfWorkManagement from '../admin/SchemeOfWorkManagement';

/**
 * Full-screen dedicated page for Scheme of Work.
 * Teachers: learningAreaId via route param or state.
 * HOS: same route with state { sowId, teacherId, readOnly, isHOS } for read-only review.
 */
const SchemeOfWorkPage = () => {
    const { courseId } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();

    const learningAreaId = state?.learningAreaId || courseId;
    const isHOSView = Boolean(state?.isHOS);
    const readOnly = Boolean(state?.readOnly || isHOSView);

    const handleBack = () => {
        if (isHOSView) {
            navigate('/teacher/hos-dashboard?tab=sow');
        } else {
            navigate(`/teacher/courses/${learningAreaId}?tab=sow`);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50">
            <SchemeOfWorkManagement
                teacherMode={!isHOSView}
                learningAreaId={learningAreaId}
                sowId={state?.sowId}
                teacherId={state?.teacherId}
                teacherName={state?.teacherName}
                readOnly={readOnly}
                autoOpenRoadmap={true}
                isFullScreen={true}
                isHOS={isHOSView}
                onBack={handleBack}
            />
        </div>
    );
};

export default SchemeOfWorkPage;
